var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasDescription())?_c('div',{staticClass:"infoIcon",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('infoIconClicked')}}},[_vm._v(" i ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }